import MainPagePortalSeguranca from '@/screens/portal/seguranca/MainPage'

import { items } from '@/screens/portal/seguranca/config'

import localStorage, { KEYS } from '@/store/local/localStorage'
import store from '@/store'

function beforeEnterLogout (to, from, next) {
  const oauth = store.getters['auth/usuarioLogado'].oauth2
  store.dispatch('auth/logout').then(resUrl => {
    localStorage.removeItem(KEYS.LOGIN.jwt)
    localStorage.removeItem(KEYS.LOGIN.usuario)
    localStorage.removeItem(KEYS.LOGIN.token)
    if (oauth) {
      window.location.href = process.env.OAUTH_LOGOUT_URL
    } else {
      next('/login')
    }
  })
}

const portalSeguranca = [
  {
    path: '/portalSeguranca',
    name: 'portalSeguranca',
    component: MainPagePortalSeguranca,
    meta: {
      isPublic: true
    },
    children: [...items]
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      isPublic: true
    },
    beforeEnter: beforeEnterLogout
  }
]

export default portalSeguranca



// WEBPACK FOOTER //
// ./src/router/portalSeguranca.js